module.exports = __webpack_public_path__ + "static/media/scroll_gallery_right.c2ca9da0.svg";